<template>
  <v-layout row justify-center>
    <v-dialog v-model="isVisible" persistent max-width="290">
      <v-card>
        <v-card-title class="headline red">
          <v-card-text style="color:white"> Log out?</v-card-text></v-card-title
        >
        <!-- <v-card-text>Your are about to log out. Are you sure you want to do it?</v-card-text> -->
        <v-card-actions>
          <v-btn color="red darken-1" text @click.native="Logout()"
            >Logout</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn color="darken-1" text @click.native="CloseDialog()"
            >Cancel</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  data() {
    return {
      isVisible: false,
    };
  },
  methods: {
    OpenDialog() {
      this.isVisible = true;
    },
    CloseDialog() {
      this.isVisible = false;
    },
    Logout() {
      this.$store.dispatch('logout');
      this.isVisible = false;
    },
  },
};
</script>

<style></style>
